import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { dateFormatter, relativeDate, timeFormatter } from '@/utils/dateHelper';
import SimpleCell from './SimpleCell';
import Dates from '../hooks/dates';

const PastDateCell = ({
  children,
  className,
  collapsing,
  colSpan,
  content,
  disabled,
  prefix = '',
  textAlign,
}) => {
  const intl = useIntl();
  Dates.useMilliSecondTick(30000);

  return (
    <SimpleCell
      className={clsx('aridhia-past-date-cell', className)}
      content={content ? relativeDate(content, intl, prefix) : undefined}
      disabled={disabled}
      colSpan={colSpan}
      collapsing={collapsing}
      textAlign={textAlign}
      title={content ? `${dateFormatter(content)} - ${timeFormatter(content)}` : undefined}
    >
      {children}
    </SimpleCell>
  );
};

export default PastDateCell;
